import React, { Suspense } from "react";
import CustomToolbarProgress from "shared/appContainers/components/Layout/CustomToolbar";
import { LoadingSpinner } from "shared/components";

type SuspensedPageViewProps = { children: React.ReactNode };

export const SuspensedPageView = ({ children }: SuspensedPageViewProps) => {
  return (
    <Suspense
      fallback={
        <>
          <CustomToolbarProgress />
          <LoadingSpinner floatingOver />
        </>
      }
    >
      {children}
    </Suspense>
  );
};
